import styled, { css } from 'styled-components'
import { colors2 as colors, transition, typoV2_CSS } from 'oolib'

export const StyledSliderContainer = styled.div`
  width: 100%;
  padding: 0.5rem 0;
`

// The track is now a dashed line with end dots
export const StyledSliderTrack = styled.div`
  position: relative;
  width: 100%;
  height: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;

  // Dashed line background (1px, 2,2 pattern) - grey80
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 6px;
    right: 6px;
    height: 0;
    border-top: 1px dashed ${colors.grey80};
    transform: translateY(-50%);
  }

  // Left end dot - grey80
  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 6px;
    height: 6px;
    background-color: ${colors.grey80};
    border-radius: 50%;
    transform: translateY(-50%);
  }
`

// Right end dot (separate element needed) - grey80
export const StyledTrackEndDot = styled.div`
  position: absolute;
  right: 0;
  top: 50%;
  width: 6px;
  height: 6px;
  background-color: ${colors.grey80};
  border-radius: 50%;
  transform: translateY(-50%);
`

// Selected range line (solid 2px) - black, z-index 1 to be above dashed line
export const StyledSliderRange = styled.div`
  position: absolute;
  top: 50%;
  height: 2px;
  background-color: ${colors.black};
  transform: translateY(-50%);
  z-index: 1;
`

// Thumb handles - 10px width, 10px height, 5px border radius
const thumbBaseStyles = css`
  position: absolute;
  top: 50%;
  width: 10px;
  height: 10px;
  background-color: ${colors.black};
  border-radius: 5px;
  transform: translate(-50%, -50%);
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  ${transition('box-shadow')}

  &:hover {
    box-shadow: 0 2px 4px ${colors.shadowHover};
  }

  &:active {
    cursor: grabbing;
  }

  &:focus {
    outline: none;
    box-shadow: 0 2px 4px ${colors.shadowHover};
  }
`

export const StyledThumb = styled.div`
  ${thumbBaseStyles}
  z-index: ${({ $isActive }) => ($isActive ? 3 : 2)};
`

export const StyledValueLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 0.75rem;
  position: relative;
  z-index: 1;
`

export const StyledInputsRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  margin-top: 1rem;
`

// A single labelled field column ("FROM" / "TO"), each takes equal width
export const StyledField = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  // ensure the input fills the column width
  & > div {
    width: 100%;
  }

  // number input text style
  & input {
    ${typoV2_CSS.UI_BODY_SM_DF}
  }
`

// Histogram container - positioned behind the slider track
export const StyledHistogramContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  height: 70px;
  padding: 0 3px; // Align with track end dots
  // margin-bottom: 8px;
`

// Individual histogram bar
export const StyledHistogramBar = styled.div`
  flex: 1;
  margin: 0 1px;
  border-radius: 4px 4px 0 0;
  background: ${colors.grey5};
  min-height: 2px; // Minimum visible height for zero-count bars
`

// Highlight overlay that sits on top of histogram bars within selected range
export const StyledHistogramHighlight = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  background: linear-gradient(180deg, hsla(215, 86%, 50%, 0.1) 0%, hsla(215, 86%, 50%, 0.3) 100%);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  pointer-events: none; // Allow clicks to pass through to bars
`
